import React, { useState } from 'react';
import { useTimelineEventDetailData } from '../../data/DataProviders/TimelineEventDetailDataProvider';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { getAlarmTitleAndSubtitle, AlarmStatus } from '../../lib/alarm-helpers';
import { GenericToolbar } from '../GenericToolbar';
import { ContentContainer } from '../ContentContainer';
import { DataIndicators } from '../DataIndicators';
import { useDeviceData } from '../../data/DataProviders/DeviceDataProvider';
import { TimelineEventDetailCard } from '../TimelineEventDetailCard';
import { isDataLoaded } from '../../types';
import { ToolbarColor } from '../GenericToolbar/GenericToolbar';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useHistory } from 'react-router-dom';
import { AppRoute } from '../../routes';
import { useSignalRSiteData } from '../../data/DataProviders/SignalRSiteDataProvider';
import {DeviceVendor } from '../../types/device';
import { DashboardRedirectBanner } from '../AutoRedirectBanner/DashboardRedirectBanner';

type Props = {
    testId?: string;
    appRoute: AppRoute;
};

export const TimelineDetailPage: React.FC<Props> = (props) => {
    const { t } = useLanguageLocale();
    const history = useHistory();
    const alarmDetailData = useTimelineEventDetailData();
    const deviceDetails = useDeviceData();
    const siteRealTimeData = useSignalRSiteData();
    const [hasAlarm, setAlarm] = useState(false);
    const backButtonOnClick = (): void => pushAppRoute(history, props.appRoute);

    let siteName = '';
   
    if (
        isDataLoaded(deviceDetails) &&
        isDataLoaded(deviceDetails.value.deviceProperties) &&
        deviceDetails.value.deviceProperties
    )
        siteName = deviceDetails.value.deviceProperties.value.siteName;
       
    const { title, subtitle } = getAlarmTitleAndSubtitle(alarmDetailData, siteName);

    React.useEffect(() => {
        setAlarm(isDataLoaded(alarmDetailData) && alarmDetailData.value.status !== AlarmStatus.Closed);
        if (siteRealTimeData && siteRealTimeData.alarmStatus && siteRealTimeData.alarmStatus.length > 0)
            setAlarm(siteRealTimeData.alarmCount > 0);
    }, [alarmDetailData, siteRealTimeData]); // eslint-disable-line react-hooks/exhaustive-deps

    const deviceVendorType = isDataLoaded(deviceDetails) &&
    isDataLoaded(deviceDetails.value.deviceProperties) &&
    deviceDetails.value.deviceProperties.value.type?.toLowerCase() === DeviceVendor.Insulgard ? "full-width" : "simple-center";

    return (
        <>
            <GenericToolbar
                showBackButton
                backButtonOnClick={backButtonOnClick}
                title={title}
                subtitle={subtitle}
                color={hasAlarm ? ToolbarColor.Error : ToolbarColor.Default}
            />
             {(isDataLoaded(alarmDetailData) && alarmDetailData.value.deviceVendor.toLowerCase() === DeviceVendor.EatonCorporation)?
               <DashboardRedirectBanner/>
               :''
            }
            <ContentContainer testId={props.testId} justifyContent={deviceVendorType}>
                <DataIndicators
                    emptyIcon="Notifications"
                    emptyMessage={t('DASHBOARD.EVENT_NOT_FOUND')}
                    errorMessage={t('DASHBOARD.ERROR_LOADING_EVENT')}
                    data={alarmDetailData}
                    isEmpty={false}
                />
                <DataIndicators
                    emptyIcon="Notifications"
                    emptyMessage={t('DASHBOARD.NO_DATA')}
                    errorMessage={t('DASHBOARD.ERROR_LOADING_DATA')}
                    data={deviceDetails}
                    isEmpty={false}
                />
              
                <TimelineEventDetailCard />
            </ContentContainer>
           
        </>
    );
};
